// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2pBiQ","label":"LabeledBox_label__2M43m"};